import React from 'react';
import {Switch} from 'react-router-dom';
import {useIntl} from 'react-intl';

import PrivateRoute from '../../components/PrivateRoute';
import withLayout from '../../components/ui/Layout';
import KillSwitchesPage from './KillSwitchesPage';

function KillSwitches() {
    const intl = useIntl();

    return (
        <Switch data-test='killSwitchesComponent'>
            <PrivateRoute
                permission='SETTINGS_UPDATE'
                exact
                path='/kill-switches'
                component={withLayout(
                    KillSwitchesPage,
                    intl.formatMessage({id: 'ROUTES.KILL_SWITCHES.INDEX'}),
                )}
            />
        </Switch>
    );
}

export default KillSwitches;
